import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Color } from 'three';

import { SceneManager } from '../../../../../../viewer/scene-manager';
import { SunManager } from '../../../../../../viewer/sun-manager';
import { useNonce } from '../../../../../hooks/use-nonce';
import { Icon } from '../../../../icon/icon';
import { Slider } from '../../../../slider/slider';
import { Stack } from '../../../../stack/stack';

const setSunDirection = (sunDirectionPercent: number) => {
  SunManager.instance.setDirection(sunDirectionPercent);
};

const LightSettings = () => {
  const [_, refresh] = useNonce();
  const { t } = useTranslation();
  const theme = useTheme();
  const [clearColor, setClearColor] = useState(SceneManager.instance.clearColor.getHex());
  const isDarkBackground = clearColor === 0x000000;

  return (
    <Stack alignItems="end" direction="row" spacing={1}>
      <Icon
        color={theme.color.gray.dark}
        icon={['fad', isDarkBackground ? 'sun-bright' : 'moon-stars']}
        title={t('lightingTool.toggleBackgroundColor', { ns: 'skyview' })}
        onClick={() =>
          setClearColor(() => {
            const newValue = isDarkBackground ? 0xccddf0 : 0x000000;
            SceneManager.instance.clearColor = new Color(newValue);
            return newValue;
          })
        }
        onHoverStyle={{ icon: ['fas', isDarkBackground ? 'sun-bright' : 'moon-stars'] }}
      />
      <Slider
        autoFocus={true}
        max={100}
        min={0}
        step={4}
        value={SunManager.instance.getDirectionPercent()}
        onChange={(val) => {
          setSunDirection(val);
          refresh();
        }}
      />
    </Stack>
  );
};

export { LightSettings };
